import moment from 'moment';

export function formatBookingDate(iso) {
  if (!iso) return '—';
  return moment(iso).format('D MMM YYYY');
}

export function statusBadgeClass(status) {
  if (status === 'paid') return 'success';
  if (status === 'waiting') return 'warning';
  if (status === 'cancelled') return 'secondary';
  return 'light';
}
